export default __webpack_public_path__ + "static/media/car.9c919750.png";